module.exports = __webpack_public_path__ + "static/media/games-image.7e273ba2.png";